import React from "react";
import { useTranslation } from "react-i18next";
import { getAdminTabMetricColumns } from "../../config/adminTabMetricColumns";
import type { AdminHotelMetricRow } from "../../types/adminHotelMetricTable";
import { AdminHotelsMetricTable } from "../shared/AdminHotelsMetricTable";

type AdminRevenueHotelsTableProps = {
  rows: AdminHotelMetricRow[];
  loading: boolean;
};

export const AdminRevenueHotelsTable = ({
  rows,
  loading,
}: AdminRevenueHotelsTableProps): React.JSX.Element => {
  const { t } = useTranslation();

  const columns = React.useMemo(() => getAdminTabMetricColumns("revenue"), []);

  return (
    <AdminHotelsMetricTable
      tab="revenue"
      columns={columns}
      rows={rows}
      loading={loading}
      emptyMessage={t(
        "analytics.admin.revenue.table.empty",
        "No revenue data for the selected period.",
      )}
    />
  );
};
